import { useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import { useSelector } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router";

import Loader from "@components/shared/Loader/Loader";
import { QueryClientProvider } from "@tanstack/react-query";
import { applyBrowserLanguage } from "@utils/user.util";

import { queryClient } from "./lib/queryClient";
import { routerPromise } from "./routes/MainRoute";
import i18n from "./i18n";
import { RootState } from "./store";

function App() {
  const [router, setRouter] = useState<ReturnType<
    typeof createBrowserRouter
  > | null>(null);

  const isAuthenticated = useSelector(
    (state: RootState) => state.local.isAuthenticated
  );

  useEffect(() => {
    routerPromise.then(setRouter);
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      applyBrowserLanguage();
    }
  }, []);

  if (!router) {
    return <Loader isLoading={true} />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <RouterProvider router={router} />
      </I18nextProvider>
    </QueryClientProvider>
  );
}

export default App;
